<template>
  <div v-if="userIsProjectAdmin || category" :title="$t('PROJECTS.CATEGORY', 2)" :class="{ 'export-hidden': ! category }">
    <!-- Edit Category -->
    <div v-if="editing" class="mt-2 position-relative">
      <project-category-edit v-model="category" :project-categories="projectCategories" prepend-icon></project-category-edit>
      <div class="mt-2 text-center">
        <v-btn color="primary" rounded @click="saveCategory">{{ $t('GLOBAL.SAVE') }}</v-btn>
      </div>
    </div>

    <!-- Category List -->
    <div v-else-if="category" class="flex-grow-1 hovervisible-activator">
      <v-icon size="small" class="mr-1" style="vertical-align: middle">far fa-tags</v-icon>
      <project-category :category="category" style="min-width: 0"></project-category>
      <v-btn-icon v-if="userIsProjectAdmin" size="x-small" class="hovervisible-item export-hidden" style="float: right" @click="$emit('update:editing', true)">
        <v-icon>far fa-pencil-alt</v-icon>
      </v-btn-icon>
    </div>

    <!-- No category -->
    <div v-else-if="userIsProjectAdmin" class="d-flex align-center">
      <v-icon size="small" class="mr-1">far fa-tags</v-icon>
      <v-btn size="small" rounded variant="outlined" @click="$emit('update:editing', true)">
        <v-icon class="mr-2">far fa-plus</v-icon>{{ $t('PROJECTS.CATEGORY') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import useUiMsgboxStore from '@/stores/ui/msgbox';
  import ProjectCategory from '@/components/Projects/ProjectCategory';
  import ProjectCategoryEdit from '@/components/Projects/ProjectCategoryEdit';

  export default {
    components: {
      ProjectCategory,
      ProjectCategoryEdit,
    },
    props: {
      planning: { type: Object, required: true },
      editing: { type: Boolean, default: false },
    },
    emits: ['update:editing'],
    data() {
      return {
        category: this.planning.meta?.category,
        projectCategories: [],
        uiMsgboxStore: useUiMsgboxStore(),
      };
    },
    computed: {
      userIsProjectAdmin() {
        return this.planning.meta.access_right == 'admin';
      },
    },
    watch: {
      editing: {
        handler(newVal) {
          if (! newVal) return;
          window.apiSrv.call('plannings/categories', 'index').then((response) => {
            this.projectCategories = response.data?.categories || [];
          });
        },
        immediate: true,
      },
    },
    methods: {
      saveCategory() {
        setTimeout(() => {
          window.apiSrv.call(`plannings`, 'update', { id: this.planning.id, category: this.category }).then(() => {
            this.planning.meta.category = this.category;
            this.$emit('update:editing', false);
          }).catch((message) => {
            this.uiMsgboxStore.open({ title: "Error : Category was not modified", body: message || "" });
            this.category = this.planning.meta?.category;
          });
        });
      },
      resetCategory() {
        this.category = this.planning.meta?.category;
        this.$emit('update:editing', false);
      },
    },
  };
</script>
